<template>
    <article class="article">
        <p class="tc fwbd mt20">个人征信授权书</p>
        <p class="fwbd">重要提示:</p>
        <p class="txin fwbd mt20">为了保障您的合法权益，您应当阅读并遵守本授权书，请您务必审慎阅读、充分理解
        本授权书条款内容，特别是免除或者减轻上海华瑞银行股份有限公司(以下简称为“被授权人”或
        “贷款人”)责任，或限制您权利的条款，其中免除或者减轻责任条款已经以加粗形式提示您特别
        关注。</p>
        <p class="txin fwbd mt20">除非您已阅读并同意本授权书所有条款，否则您无权使用“华瑞银行·众安保险场景贷业务
        ”(即被授权人与众安在线财产保险股份有限公司合作项下的消费类贷款信用保险服务产品，产品
        清单详细见附件，以下简称“场景贷”)相关产品服务。您的登录、使用等行为即视为您已阅读并
        同意接受本授权书条款的约束。</p>
        <p class="mt20">上海华瑞银行股份有限公司:</p>
        <p class="txin mt20">一、本人同意并不可撤销地授权:<span class="fwbd">贷款人按照国家相关规定采集符合法律法规规定的本人个人信息及包括信贷信息在内的信用信息(含
        本人在贷款人处办理业务时产生的不良信息)，并可以向中国人民银行金融信用信息基础数据库、
        其他依法设立的征信机构提供以上信息。</span></p>
        <p class="txin mt20">二、本人同意并不可撤销地授权:<span class="fwbd">贷款人可以根据国家有
        关规定，通过中国人民银行金融信用信息基础数据库、其他依法设立的征信机构、公安部公民身份
        信息数据库、第三方机构(包括但不限于本人工作单位、社保、公积金、税务、民政、通讯运营商
        等)查询、打印、保存符合法律法规规定的本人个人信息和包括信贷信息在内的信用信息。</span>用途如下:</p>
        <p class="txin mt20">(一) 审核本人贷款申请;</p>
        <p class="txin mt20">(二) 处理贷后管理事务;</p>
        <p class="txin mt20">(三) 处理本人征信异议;</p>
        <p class="txin mt20">(四) 依法或经有权部门要求;</p>
        <p class="txin mt20">(五) 审核本人向贵行申请或办理其他业务的申请。</p>
        <p class="txin mt20 fwbd">授权人声明:</p>
        <p class="txin mt20 fwbd">本授权书是本人向上海华瑞银行股份有限公司做出的单方承诺，效力具有独立性，不因场景贷《借款合同》的
        任何条款无效而失效。</p>
        <p class="txin mt20">以上授权期限为本人作出本授权承诺之日起至本人在贷款人处所有业务终结
        之日止。<span class="fwbd">本人在贷款人处有借款额度但无借款余额的情况下，本人与贷款人的业务关系仍然存续，
        贷款人仍有权向中国人民银行金融信用信息基础数据库查询、上报本人的信用信息。</span></p>
        <p class="txin mt20 fwbd">若本人与被授权人发生任何纠纷或争议，首先应友好协商解决;协商不成的，本人同意将纠纷或争议提交本授权
        书签订地(即中国上海市浦东新区)有管辖权的人民法院管辖。本授权书的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律(不包括冲突法)。</p>
        <p class="txin mt20 fwbd">本人已知悉本授权书所有内
        容(特别是加粗字体内容)的意义以及由此产生的法律效力，自愿作出上述授权，本授权书是本人
        真实的意思表示，本人同意承担由此带来的一切法律后果。</p>
        <p class="txin mt20">特此授权!</p>
    </article>
</template>

<script>
    export default {
        beforeRouteEnter (to, from, next) {
            document.title = '个人征信授权书'
            next()
        }
    }
</script>


// WEBPACK FOOTER //
// percontract.vue?3c2c8061